<template>
  <div class="assessment px-4">
    <img src="@/assets/preview/assessment_card.jpg" height="200" alt="AssessmentCard" class="mb-4" />
    <img src="@/assets/preview/assessment_landing.jpeg" height="200" alt="AssessmentLanding" class="mb-4" />
    <img src="@/assets/preview/assessment_result.jpeg" height="200" alt="AssessmentLanding" class="mb-4" />
    <assessment-table :assessments="assessments" @onFetch="fetchAssessment" />
  </div>
</template>

<script>
import { Vue } from 'vue-property-decorator';
import store from '../../../store';
import AssessmentService from '../../../services/assessment';
import AssessmentTable from './AssessmentTable.vue';
export default Vue.extend({
  store,
  components: {
    AssessmentTable,
  },
  data: () => ({
    language: 'both',
    assessments: [],
  }),
  mounted() {
    this.fetchAssessment();
  },
  methods: {
    fetchAssessment() {
      AssessmentService.fetchAssessment(this.language).then((assessments) => {
        this.assessments = assessments;
      });
    },
    deleteSection(id) {
      this.$root.$confirm('delete section', `This change will take effect on app immediately.`, id, {
        color: 'primary',
      });
    },
  },
});
</script>
<style lang="css" scoped></style>
